<div class="container-fluid-modal">

<form class="form-inline required" #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

<div class="add" *ngIf="!editData">
    <div class="ModalHeader">
        <h4 mat-dialog-title>Add Country</h4>
        <div class="headerButton">
            <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
            </button>
            <button type="button" class="btn btn-warning"  matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true" ></i> Cancel
            </button>
        </div>
    </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                    <div class="form-group col-lg-12">
                        <div class="form-group col-lg-12">
                            <label for="Region" class="labelRequired">Region </label>
                            <select id="mySelect" data-show-content="true" class="form-control" placeholder="Region"
                                [(ngModel)]="model.region_id" name="region_id" required #region_id="ngModel" [ngClass]= "{'has-danger': cat?.submitted  && region_id?.invalid }">
                                <option disabled>Select Region</option>
                                <option *ngFor="let data of regionsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                            </select>
                            <div *ngIf="cat?.submitted  && region_id?.invalid">
                                    <div [hidden]="!region_id.errors.required" class="formError"> * Region Name is required </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="Country" class="labelRequired">Country </label>
                            <input type="text" class="form-control" placeholder="Country" name="name" #name="ngModel" [(ngModel)]="user.name" required [ngClass]= "{'has-danger': cat?.submitted  && name?.invalid }">
                            <div *ngIf="cat?.submitted  && name?.invalid ">
                                <div [hidden]="!name.errors.required" class="formError"> * Country Name is required </div>
                            </div>
                        </div>
                </div>
            </div>

        </div>

    </mat-dialog-content>
</div>

    <div class="edit" *ngIf= "editData">
                <div class="ModalHeader">
                    <h4 mat-dialog-title>Edit Country</h4>
                    <div class="headerButton">
                        <button *ngIf="editPermission" type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                        </button>
                        <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                                class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>

                <mat-dialog-content>
                    <div class="card">
                        <div class="card-body">
                        <div class="form-group col-lg-12">
                            <div class="form-group col-lg-12">
                                <label for="Region" class="labelRequired">Region </label>
                                <select id="mySelect" data-show-content="true" class="form-control" placeholder="Region"
                                [(ngModel)]="regionId" name="region_id">
                                    <option disabled>Select Region</option>
                                    <option *ngFor="let data of regionsData" [value]="data?.id">
                                        {{data?.name}}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="Country" class="labelRequired">Country </label>
                                <input type="text" class="form-control" placeholder="Country" name="name" [(ngModel)]="editData.country.name" required #name="ngModel" [ngClass]="{'has-danger':cat?.submitted && name?.invalid }">
                                <div *ngIf="cat?.submitted && name?.invalid">
                                    <div [hidden]="!name.errors.required" class="formError"> *Country Name is required </div>
                                </div>
                            </div>
                        </div>

                        </div>

                    </div>

                </mat-dialog-content>
            </div>

    </form>
</div>
